//--------------------------------------------------------------------//
//******************** emailSettingsCtrl *********************************//
//--------------------------------------------------------------------//
// Controller for the Email settings page - mirrors sipTrunksCtrl exactly:
// fetches the provider list on load, and provides the "Add Provider" dialog
// (name + type) followed immediately by the full-screen provider detail
// popup (Provider Info / Accounts tabs, see openProviderDetail below).
// Clicking a provider row later reopens the same detail popup. Accounts are
// NOT fetched here - each provider detail popup's Accounts tab loads its
// own (see providerAccounts.tab.js), same way trunk-numbers.tab.js owns
// trunk.did_numbers rather than sipTrunksCtrl owning it.
import addEmailProviderDialogTemplateUrl from './add-email-provider-dialog.template.html';

angular.module('userSettingsMod')

.controller('emailSettingsCtrl', ['$scope', 'GhDialog', 'EmailSettingsService', 'localizationService', '$templateCache', async function($scope, GhDialog, EmailSettingsService, localizationService, $templateCache) {
  const dictionary = localizationService.getDictionary('account_settings');
  $scope.translate = (word) => localizationService.translate(word, dictionary);

  $scope.providers = [];

  // Fetches all email providers from the server and populates the list.
  $scope.getProviders = async function() {
    try {
      $scope.providers = await EmailSettingsService.getProviders();
      $scope.$evalAsync();
    } catch (error) {
      console.log('Load email providers error:', error);
    }
  };

  // Opens the full-screen provider detail popup with Provider Info and
  // Accounts tabs.
  $scope.openProviderDetail = function(provider) {
    const outerScope = $scope;

    GhDialog.show({
      position: 'full',
      toolbar: false,
      template: {
        toolbar: '',
        content: `
          <div class="email_provider-popup">
              <div class="email_provider-popup__header">
                  <div class="email_provider-name-wrapper">
                      <div class="email_provider_name_input">{{provider.name}}</div>
                  </div>

                  <div class="email_provider-status-wrapper">
                      <span class="status-badge" ng-class="provider.enabled ? 'running' : 'stopped'">
                          {{provider.enabled ? translate('Enabled') : translate('Disabled')}}
                      </span>
                  </div>

                  <span
                      class="close_dialog"
                      ng-click="cancel()"
                      gh-icon="cross #0D99FF 30px"
                  ></span>
              </div>

              <div class="email_provider-popup__nav-panes">
              <div class="email_provider-popup__nav-track" ng-class="{'--detail_open': tabDetailOpen}">
              <div class="email_provider-popup__tabs">
                  <div class="email_provider-popup__tab"
                       ng-class="{'email_provider-popup__tab--active': activeTab === 'info'}"
                       ng-click="activeTab = 'info'; tabDetailOpen = true;">
                      {{translate('Provider Info')}}
                      <span class="email_provider-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
                  <div class="email_provider-popup__tab"
                       ng-class="{'email_provider-popup__tab--active': activeTab === 'accounts'}"
                       ng-click="activeTab = 'accounts'; tabDetailOpen = true;">
                      {{translate('Accounts')}}
                      <span class="email_provider-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
              </div>

              <div class="email_provider-popup__content-pane">
              <div class="email_provider-popup__mobile-header">
                  <span class="email_provider-popup__mobile-back" ng-click="tabDetailOpen = false">
                      <span gh-icon="arrow_left 0893d2 24px normal"></span>
                  </span>
                  <span ng-if="activeTab === 'info'">{{translate('Provider Info')}}</span>
                  <span ng-if="activeTab === 'accounts'">{{translate('Accounts')}}</span>
              </div>
              <div class="email_provider-popup__content">
                  <div class="email_provider-info" ng-show="activeTab === 'info'">
                      <provider-info-tab provider="provider" on-update="onProviderUpdate()"></provider-info-tab>
                  </div>

                  <div class="email_provider-accounts-wrapper" ng-show="activeTab === 'accounts'">
                      <provider-accounts-tab provider="provider"></provider-accounts-tab>
                  </div>
              </div>
              </div>
              </div>
              </div>
          </div>
        `
      },
      locals: {
        provider
      },
      controller: ['$scope', 'provider', 'localizationService', function($scope, provider, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.provider = provider;
        $scope.activeTab = 'info';
        $scope.tabDetailOpen = false;

        $scope.onProviderUpdate = function() {
          outerScope.$applyAsync();
        };
      }]
    });
  };

  // Opens the "Add Provider" dialog - name + type. On success, immediately
  // opens the provider detail popup so the user can fill in the connection
  // settings (for generic_imap) or leave it as-is (for google).
  $scope.showAddProviderDialog = function() {
    GhDialog.show({
      position: 'center',
      toolbar: false,
      locals: {
        providers: $scope.providers,
        safeApply: () => $scope.$evalAsync()
      },
      template: {
        toolbar: '',
        resizable: false,
        content: $templateCache.get(addEmailProviderDialogTemplateUrl)
      },
      controller: ['$scope', 'providers', 'safeApply', 'EmailSettingsService', 'localizationService', function($scope, providers, safeApply, EmailSettingsService, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.errMessage = '';
        $scope.provider = { name: '', type: 'google' };
        $scope.isCreating = false;

        $scope.addProvider = async function() {
          const name = ($scope.provider.name || '').trim();
          if (!name) {
            $scope.errMessage = 'Please, type a provider name';
            return;
          }

          $scope.isCreating = true;

          try {
            const created = await EmailSettingsService.createProvider({
              name,
              type: $scope.provider.type,
              created_by: gudhub.storage.user.user_id
            });

            providers.push(created);
            safeApply();
            $scope.hide(created);
          } catch (error) {
            console.log('Add email provider error:', error);
            $scope.errMessage = error.message || 'Something went wrong. Please, try again';
            $scope.isCreating = false;
            $scope.$evalAsync();
          }
        };
      }]
    }).then(function(created) {
      if (created) {
        $scope.openProviderDetail(created);
      }
    });
  };

  await $scope.getProviders();

}]);
